module.exports = __webpack_public_path__ + "static/media/logo.593f96da.png";